

function range(max) {
  return [...Array(max).keys()];
}

function slug(string) {
  return string.replace(/ /g, "-").replace(/[^\w-]/g, "").toLowerCase();
}

export {range, slug};




// WEBPACK FOOTER //
// ./src/Util.js